import { Grid } from "@mui/material";
import { useSubServicesMap } from "../../../data/sub-service/useSubServices";
import NWONSubServiceCard from "../../02-molecules/NWONSubServiceCard/NWONSubServiceCard";
import { NWONSubServiceCardGridProps } from "./NWONSubServiceCardGridInterfaces";

const NWONSubServiceCardGrid = (
  props: NWONSubServiceCardGridProps
): JSX.Element => {
  const { subServices } = props;
  const subServiceMap = useSubServicesMap();

  return (
    <Grid container={true} spacing={1} justifyContent={"center"}>
      {subServices.map((subService) => {
        return (
          <Grid item={true} sm={12} md={6} lg={4} key={subService}>
            <NWONSubServiceCard subService={subServiceMap[subService]} />
          </Grid>
        );
      })}
    </Grid>
  );
};

export default NWONSubServiceCardGrid;
